import React, { useMemo, useState } from "react";
import { Button, Badge } from 'reactstrap';
import { FaFileExcel, FaFilePdf, FaFileDownload, FaCheck } from "react-icons/fa";
import { CSVLink, CSVDownload } from "react-csv";
import { downloadPDF } from "./pdfReport";
import { downloadTextReport } from "./textReport";


import { useTable, useExpanded, useFilters, usePagination } from "react-table";
import { RelevantIcon, handleFilter, download_csv, download_xlsx, normalizeDisplayData } from "../oro-module/commonFunctions";
import { handleSearch } from "../oro-module/ajaxdata";
import { fetchData } from "../common/networkRequests";
import { ToggleCustom } from "../FormComponents";

export const openRecord = async ({ current, unique_id }) => {
  current.props.liftGlobalState({ name: 'isPopulating' }, true);
  let { token } = current.props.parentProps.parentState;
  let { pageData, remoteip, currentPage } = current.props.parentState;
  pageData['unique_id'] = unique_id;
  let CBSurl = `${remoteip}/sentry`;
  let url = CBSurl;
  let editThis = { token, dataType: 'edit', pageData, currentPage };

  let response = await fetchData({ url, postData: editThis, method: 'post', headers: { Authorization: `JWT ${token}` } });

  if (response && response.results && response.results.length > 0) {
    pageData = response.results[0];
    pageData['unique_id'] = unique_id;

    handleFilter({ current, act: "hide" });
    current.props.liftGlobalState({ name: 'pageData' }, pageData);
  } else {
    alert("Not allowed");
    window.close();
    // let notifications = { value: "No data found. Try refreshing page.", alertType: "warning" };
    // current.props.liftGlobalState({ name: "notifications" }, notifications);
  }
  current.props.liftGlobalState({ name: 'isPopulating' }, false);
  current.props.liftGlobalState({ name: 'directloading' }, false);
}

function checkContainsCurrency({ displayColumns, containsCurrency = false }) {
  if (!containsCurrency) {
    for (var i = 0; i < displayColumns.length; i++) {
      let col = displayColumns[i];
      if (col.columns) {
        containsCurrency = checkContainsCurrency({ displayColumns: col.columns, containsCurrency });
      } else if (col.type == 'currency') {
        containsCurrency = true;
      }
      if (containsCurrency) {
        break;
      }
    }
  }
  return containsCurrency;
}

const cleanCols = (origCols) => {
  let allcols = [];

  for (var i = 0; i < origCols.length; i++) {
    let dc = origCols[i];
    if (!dc.hide) {
      let nc = dc;
      let proceed = true;
      if (dc.columns) {
        let tmp = cleanCols(dc.columns);
        nc.columns = tmp;
        if (tmp.length == 0) {
          proceed = false;
        }
      }
      if (proceed) {
        allcols.push(nc);
      }
    }
  }
  return allcols;
}

const HistoryTable = ({ ReportsData, displayColumns, current, startingParams = {} }) => {
  let { pi, exp } = startingParams;
  // Using reac-table-7 for efficient MULTISORT & Grouping.
  let containsCurrency = checkContainsCurrency({ displayColumns });
  let shownColumns = cleanCols(displayColumns);

  let tableheight = startingParams['tableheight'] ? startingParams['tableheight'] : 500;
  let { pageData, historyTableParams, isPopulating, formElements, currentPage, remoteip, systemPivoted, showCharts, startingPage, openControls } = current.props.parentState;
  let { history, form, isnotif } = formElements[currentPage];
  let { extraRows, pivot, pivotable, charts, textReportProps } = history;
  let { perPage } = historyTableParams;
  // if (perPage < 25) { perPage = 25; }

  // console.log({ ReportsData, displayColumns })
  let z;

  !extraRows ? extraRows = {} : z = 0;


  const getShownData = ({ ReportsData, prev = '' }) => {
    let flatData = [];
    if (ReportsData) {
      for (var i = 0; i < ReportsData.length; i++) {
        let curidx = prev + i;
        if (extraRows.location == "top") {
          flatData.push(ReportsData[i]);
        }
        if (expanded[curidx]) {
          flatData = flatData.concat(getShownData({ ReportsData: ReportsData[i].subRows, prev: i + '.' }))
        }
        if (extraRows.location == "bottom") {
          flatData.push(ReportsData[i]);
        }
      }
    }

    return flatData;
  }

  const handleDownloadPdf = ({ dataType }) => {
    let printData = [];
    if (dataType == 'shown') {
      current.props.liftGlobalState({ name: "pdfdownloading" }, true);
      printData = getShownData({ ReportsData });
    } else if (dataType == 'full') {
      current.props.liftGlobalState({ name: "pdfdownloadingfull" }, true);

      printData = normalizeDisplayData({ ReportsData, extraRows });
    }
    setTimeout(() => {
      downloadPDF({ reportData: printData, statutoryColumns: shownColumns, current, sentData: printData });
      current.props.liftGlobalState({ name: "pdfdownloading" }, false);
      current.props.liftGlobalState({ name: "pdfdownloadingfull" }, false);
    }, 10)
  }


  const getDataToDisplay = (ReportsData) => {
    if (pivot || systemPivoted) {
      return ReportsData;
    } else {
      return normalizeDisplayData({ ReportsData, extraRows });
    }
  }

  const handleDownloadText = ({ dataType }) => {
    let basicParams = {
      pageHeader: {},
      pageFooter: {},
      page80: {
        separator: " ",
        height: 64, headeralign: 'center'
        // wraplines: 1, padding: { type: 'left', size: 2, padder: ' ' } 
      },
      page132: { height: 80, separator: " ", },
    };

    for (var key in textReportProps) {
      basicParams["page" + key] = textReportProps[key];
    }

    current.props.liftGlobalState({ name: "textdownloading" }, true);
    let printData = [];
    if (dataType == 'shown') {
      printData = getShownData({ ReportsData });
    } else if (dataType == 'full') {
      printData = normalizeDisplayData({ ReportsData, extraRows });
    }
    setTimeout(() => {
      downloadTextReport({ reportData: printData, statutoryColumns: shownColumns, current, sentData: printData, basicParams });
      current.props.liftGlobalState({ name: "textdownloading" }, false);
    }, 10);
  }

  let tableColumns = [];
  if (pivot || systemPivoted) {
    tableColumns = [
      {
        // Build our expander column
        id: 'expander', // Make sure it has an ID
        align: "center",
        Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
          <span {...getToggleAllRowsExpandedProps()}>
            {isAllRowsExpanded ? <div className="row-pivot-icon-dark">-</div> : <div className="row-pivot-icon-dark">+</div>}
          </span>
        ),
        Cell: ({ row }) => {
          if (row.canExpand) {
            return (
              <span
                {...row.getToggleRowExpandedProps()}
              >
                {row.isExpanded ? <div className="row-pivot-icon-light">-</div> : <div className="row-pivot-icon-light">+</div>}
              </span>
            )
          } else {
            return null;
          }
        }
      }];
  }

  tableColumns = tableColumns.concat(shownColumns);
  let data = useMemo(() => getDataToDisplay(ReportsData), [ReportsData, systemPivoted]);
  let columns = useMemo(() => {
    // console.log({ displayColumns, systemPivoted }); 
    return tableColumns;
  }, [displayColumns, systemPivoted]); // using shownColumns instead of displayColumns makes this go in infinite loop.

  const forceNextPage = () => {
    // Check if more data exists. send starting id and total records.
    let fulldata = normalizeDisplayData({ ReportsData, extraRows });
    let lastuid = fulldata[fulldata.length - 1].unique_id;
    current.props.liftState({ name: 'startingUID' }, lastuid);
    current.props.liftGlobalState({ name: 'startingPage' }, pageIndex);
    handleSearch({ current, pageData, loadOnly: true });
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { expanded, pageIndex, pageSize },
  } = useTable({ columns, data, initialState: { pageIndex: pi ? pi : 0, pageSize: perPage ? perPage : 10 } }, useExpanded, useFilters, usePagination);

  const handleTdClick = async ({ cell, seq }) => {
    let { unique_id, ui_fastpath } = cell.row.original;
    if (isnotif) {
      let baseurl = window.location.origin;
      window.open(`${baseurl}/${ui_fastpath}/${unique_id}`, "_blank");
    } else {
      if (form && form.length > 0) {
        // fetch data for unique_id, change to create mode, set mode as edit and set it to pageData.
        // if edit mode, then show delete, update, audit buttons.

        let { pageData, historyTableParams, isPopulating, formElements, currentPage, remoteip, systemPivoted, showCharts, startingPage, openControls } = current.props.parentState;
        let { formActions } = formElements[currentPage];

        if (formActions && (!formActions.open || formActions.open.allow)) {
          if (openControls.length > 0) {
            if (openControls.length == 1) {
              let target = openControls[0]['target'].replace("_code", "_id");
              pageData[target] = unique_id;
              current.props.liftGlobalState({ name: 'pageData' }, pageData);
              openControls.pop();
              current.props.liftGlobalState({ name: 'openControls' }, openControls);
            } else {
              let target = openControls[openControls.length - 1]['target'].replace("_code", "_uid");
              openControls[openControls.length - 2]['values'][target] = unique_id;
              current.props.liftGlobalState({ name: 'openControls' }, openControls);
            }
          }
          else {
            openRecord({ current, unique_id });
          }
        }
      } else {
        if (cell.column.id != 'expander') {
          let expanderID = document.getElementById('expander' + cell.row.id);
          if (expanderID) {
            try {
              expanderID.childNodes[0].childNodes[0].click();
            } catch (e) {

            }
          }
        } else {
          return true;
        }
      }
    }
  }

  return (
    <div >
      <div className="hiddenBtn" id="pdf-download-button-cont" onClick={() => handleDownloadPdf({ dataType: 'shown' })}>
        <Button
          outline
          size="sm"
          id="pdf-download-button"
        >
          <FaFilePdf /> PDF
        </Button>
      </div>

      <div className="hiddenBtn" id="pdf-download-button-full" onClick={() => handleDownloadPdf({ dataType: 'full' })}>
        <Button
          outline
          size="sm"
          id="pdf-download-button2"
        >
          <FaFilePdf /> PDF
        </Button>
      </div>

      <div className="col-sm-6 hiddenBtn" id="text-download-button-cont"
        onClick={() => handleDownloadText({ dataType: "shown" })}>
        <Button
          outline
          size="sm"
          id="text-download-button"
        >
          <FaFileDownload /> TEXT
        </Button>
      </div>
      <div className="col-sm-6 hiddenBtn" id="text-download-button-full"
        onClick={() => handleDownloadText({ dataType: "full" })}>
        <Button
          outline
          size="sm"
          id="text-download-button"
        >
          <FaFileDownload /> TEXT
        </Button>
      </div>


      <div className="col-sm-6 hiddenBtn" id="xlsx-download-button-full" onClick={() => download_xlsx({ ReportsData, history, shownColumns, extraRows })}
      >
        <Button
          outline
          size="sm"
          id="xlsx-download-button"
        >
          {/* <CSVLink  data={csvData}></CSVLink> */}
        </Button>
      </div>


      <div className="col-sm-6 hiddenBtn" id="csv-download-button-full" onClick={() => download_csv({ ReportsData, history, shownColumns, extraRows })}
      >
        <Button
          outline
          size="sm"
          id="csv-download-button"
        >
          {/* <CSVLink  data={csvData}></CSVLink> */}
        </Button>
      </div>



      <div className="col-sm-6 hiddenBtn" id="set-page-size"
        onClick={() => setPageSize(perPage)}>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div style={{ float: 'right' }}>

            {charts &&
              <div style={{ float: "left", fontSize: 12, paddingLeft: 10 }}>
                <ToggleCustom isChecked={showCharts} display="Charts" setChecked={(r) => { current.props.liftGlobalState({ name: 'showCharts' }, r); current.props.liftGlobalState({ name: "showSidebar" }, false); }} />
              </div>
            }

            {pivotable &&
              <div style={{ float: "left", fontSize: 12, paddingLeft: 10 }}>
                <ToggleCustom isChecked={systemPivoted} display="Pivot" setChecked={(r) => current.props.liftGlobalState({ name: 'systemPivoted' }, r)} />
              </div>
            }

            {/* <label className="hand">
<input onChange={(e) => current.props.liftGlobalState({ name: 'systemPivoted' }, e.target.checked)} type="checkbox" name="is-pivot" checked={systemPivoted} />
&nbsp; Group &nbsp;
 </label> */}

            {containsCurrency &&
              <div style={{ float: "left" }}>
                <div style={{ float: "left", fontSize: 12, paddingTop: 2 }}>
                  Amounts in &nbsp;
                </div>
                <div style={{ float: 'left' }}>
                  <select
                    className="form-control form-control-sm"
                    style={{ padding: 0, height: 20 }}
                    value={
                      current.props.parentState.pageData.currency_convert
                    }
                    onChange={(e) => current.props.liftState({ name: "currency_convert" }, e.target.value)}
                  >
                    <option value="Rupees">Rupees</option>
                    <option value="Thousands">Thousands</option>
                    <option value="Lakhs">Lakhs</option>
                    <option value="Crores">Crores</option>
                  </select>
                </div>
              </div>
            }

            {canPreviousPage &&
              <div className="hand pagination-arrow enabled-arrow" id="paginate-back" onClick={() => previousPage()} >
                <RelevantIcon icon="prev-page" style={{ color: "#3f4441" }} />
              </div>
            }

            {!canPreviousPage &&
              <div className="hand pagination-arrow" id="paginate-back"  >
                <RelevantIcon icon="prev-page" style={{ color: "lightgray" }} />
              </div>
            }

            <div style={{ float: 'left' }}>
              <input
                className="reportPageNo"
                type="number"
                value={pageIndex + 1}
                onChange={e => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                }}
              />
              <span style={{ color: "lightgray" }}>&nbsp;/  {pageOptions.length}</span>
            </div>

            {canNextPage &&
              <div className="hand pagination-arrow enabled-arrow" id="paginate-forward" onClick={() => nextPage()} >
                <RelevantIcon icon="next-page" style={{ color: "#3f4441" }} />
              </div>
            }

            {!canNextPage &&
              <div className="hand pagination-arrow" id="paginate-forward" onClick={() => form.length > 0 ? forceNextPage(pageIndex) : false}  >
                <RelevantIcon icon="next-page" style={{ color: "lightgray" }} ></RelevantIcon>
              </div>
            }
          </div>
        </div>
      </div>

      <div className="history-table" style={{ maxHeight: tableheight }}>
        {isPopulating &&
          <div className="table-curtain">Please wait . . .</div>
        }

        <table {...getTableProps()} style={{ border: 'solid 1px white', width: "100%" }}>

          <thead >
            {headerGroups.map(headerGroup => (
              <tr
                {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => {
                  let align = column.align ? column.align : column.columns ? 'center-column' : column.type == 'currency' ? 'currency-type' : '';
                  return (
                    <th
                      {...column.getHeaderProps()}
                      className={`table-header ${align}`}
                    >
                      {column.render('Header')}
                    </th>
                  )
                })
                }
              </tr>
            ))}
          </thead>
          <tbody  {...getTableBodyProps()}>
            {page.map((row, idx) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell, cidx) => {
                    return (
                      <td id={`${cell.column.id}${cell.row.id}`} onClick={() => handleTdClick({ cell, seq: cidx })}
                        {...cell.getCellProps()}
                        className={` ${form ? 'hand' : ''} report-row  ${idx % 2 == 0 ? 'even-row' : 'odd-row'} ${row.original.skip_rows ? row.original.skip_rows : ''} ${row.original.group_level ? row.original.group_level : ''}`}
                      // style={{textAlign:}}
                      >
                        {cell.render('Cell')}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div >
  )
}

const HistoricalData = ({ ReportsData, displayColumns, current, startingParams }) => {

  return (
    <HistoryTable startingParams={startingParams} ReportsData={ReportsData} displayColumns={displayColumns} current={current} />
  )
}

export default HistoricalData;